"use client";

import { OfferHero, type OfferHeroProps } from "@/composite/OfferHero";

import { OfferHeroBlockProps } from ".";

/**
 * Offer Hero block
 */
export function OfferHeroBlock({
	eyebrow,
	headline,
	headline_tag,
	headline_typography_style,
	theme
}: OfferHeroBlockProps): JSX.Element {
	return (
		<OfferHero
			eyebrow={eyebrow}
			headline={headline}
			headlineTag={headline_tag as OfferHeroProps["headlineTag"]}
			headlineStyle={
				headline_typography_style as OfferHeroProps["headlineStyle"]
			}
			theme={theme as OfferHeroProps["theme"]}
		/>
	);
}
